import { atom } from 'jotai';

export interface AnalysisState {
  isAnalyzing: boolean;
  progress: number;
  status: string;
  statusValue: string;
}

// Global analysis state - shared across all components viewing the same portfolio
export const analysisStateAtom = atom<AnalysisState>({
  isAnalyzing: false,
  progress: 0,
  status: '',
  statusValue: '',
});

// Dialog visibility
export const aumDialogVisibleAtom = atom<boolean>(false);
